/**
* Virtual Consultation Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Virtual Consultation Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'virtual-consultation-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // $( '.virtual-consultation-callout' ).each( function( key, val ) {
      //   const height = $( this ).outerHeight();

      //   const tl = gsap.timeline( {
      //     scrollTrigger: {
      //       trigger: this,
      //       start: 'top top',
      //       end: 'bottom top',
      //       pin: true,
      //       scrub: 0,
      //       markers: false,
      //     },
      //   } );
      // } );

      // $( '.virtual-consultation-callout' ).each( function() {
      //   const enter = gsap.timeline( {
      //     scrollTrigger: {
      //       trigger: this,
      //       start: 'top 50%',
      //       // end: "top top-=800px",
      //       end: '50% top',
      //       pin: false,
      //       scrub: true,
      //       // markers: true,
      //       stagger: 0.25,
      //     },
      //   } );
      //   enter.fromTo(
      //       $( this ).find( '.container' ),
      //       {filter: 'blur(10px)', opacity: '0', ease: 'linear'},
      //       {filter: 'blur(0px)', opacity: '1', ease: 'linear'},
      //   );

      //   const exit = gsap.timeline( {
      //     scrollTrigger: {
      //       trigger: this,
      //       start: '75% 50%',
      //       end: '100% 50%',
      //       pin: false,
      //       scrub: true,
      //       // markers: true,
      //       stagger: 0.25,
      //     },
      //   } );
      //   exit.fromTo(
      //       $( this ).find( '.container' ),
      //       {filter: 'blur(0px)', opacity: '1', ease: 'linear'},
      //       {filter: 'blur(10px)', opacity: '0', ease: 'linear'},
      //   );
      // } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'virtual-consultation-callout', COMPONENT );
} )( app );
